import { TShipmentsType } from "../models/iShipments";
import { TOrdersType } from "../models/iOrders";

export enum MESSAGE_SEVERITY {
  error = "error",
  warning = "warning",
  info = "info",
  success = "success",
}

export const ALL = "all" as const;

interface IShipmentType {
  name: TShipmentsType;
  value: string;
}

interface IOrderType {
  name: TOrdersType;
  value: string;
}

export const shipmentTypes: IShipmentType[] = [
  { name: "air", value: "Авиа" },
  { name: "railway", value: "ЖД" },
];
export const transporters = [
  "Адамант",
  "Байкал",
  "Деловые Линии",
  "Почта",
  "ПЭК",
  "СДЭК",
  "Энергия",
  "Дмитрий Павлович",
  "Евгений Владимирович",
] as const;
export const ordersTypes: IOrderType[] = [
  { name: "current", value: "Текущая" },
  { name: "annual", value: "Годовая" },
];

export const CANCEL_TEXT = "Отменён";
export const NO_TEXT = "Нет";
export const FILE_TYPE = "file";





